module.exports = __webpack_public_path__ + "static/media/AppGallery.55251ee1.png";